// extracted by mini-css-extract-plugin
export default {"header":"AssignmentsHeader_header__SXBER","title":"AssignmentsHeader_title__sKZPi","tabs":"AssignmentsHeader_tabs__-FT-h"};